import { getQuickReply
// @ts-expect-error Untyped import
} from 'conversations-message-history/common-message-format/operators/cmfQuickReplyGetters';
import { getOptionLabel, getOptionValue
// @ts-expect-error Untyped import
} from 'conversations-message-history/quick-reply/operators/quickReplyGetters';
import { List as ImmutableList, Set as ImmutableSet } from 'immutable';
import { PureComponent } from 'react';
import VizExCheckbox from 'visitor-ui-component-library/input/VizExCheckbox';
import VizExIconButton from 'visitor-ui-component-library/button/VizExIconButton';
import VizExIcon from 'visitor-ui-component-library/icon/VizExIcon';
import SVGSuccess from 'visitor-ui-component-library-icons/icons/SVGSuccess';
import styled from 'styled-components';
import ThemeContext from '../theming/contexts/ThemeContext';
import { RIGHT_ALIGNED } from 'conversations-internal-schema/widget-location/constants/WidgetLocations';
import QuickReplyButton from './QuickReplyButton';
import { jsx as _jsx } from "react/jsx-runtime";
const ButtonWrapperInsideChat = styled.div.withConfig({
  displayName: "QuickReplyGroup__ButtonWrapperInsideChat"
})(["gap:8px;padding-top:8px;align-items:center;display:flex;flex-wrap:wrap;width:100%;"]);
const ButtonWrapperOutsideChat = styled.div.withConfig({
  displayName: "QuickReplyGroup__ButtonWrapperOutsideChat"
})(["flex-wrap:wrap;width:240px;gap:8px;align-items:center;display:flex;flex-direction:row;justify-content:", ";"], ({
  $widgetLocation
}) => $widgetLocation !== RIGHT_ALIGNED ? 'flex-start' : 'flex-end');
const UpdatedCheckbox = styled(VizExCheckbox).withConfig({
  displayName: "QuickReplyGroup__UpdatedCheckbox"
})(["margin-right:8px;> *{color:", ";}"], ({
  theme
}) => {
  var _theme$colors;
  return (_theme$colors = theme.colors) === null || _theme$colors === void 0 ? void 0 : _theme$colors.primary;
});
class QuickReplyGroup extends PureComponent {
  constructor(props) {
    super(props);
    this.handleSendMulti = this.handleSendMulti.bind(this);
    this.handleQuickReplySend = this.handleQuickReplySend.bind(this);
    this.handleSendIndividual = this.handleSendIndividual.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.state = {
      selected: ImmutableSet()
    };
  }
  hasSelected() {
    const {
      selected
    } = this.state;
    return selected.size > 0;
  }
  handleSelect(option) {
    this.setState(({
      selected
    }) => {
      const updatedSelected = selected.includes(option) ? selected.delete(option) : selected.add(option);
      return {
        selected: updatedSelected
      };
    });
  }
  handleSendMulti() {
    const {
      selected
    } = this.state;
    if (this.hasSelected()) {
      const text = selected.map(getOptionLabel).join(', ');
      this.handleQuickReplySend(text, selected);
    }
  }
  handleSendIndividual(option) {
    const options = ImmutableList([option]);
    const text = getOptionLabel(option);
    this.handleQuickReplySend(text, options);
  }
  handleQuickReplySend(text, options) {
    const {
      message,
      publishMessage
    } = this.props;
    const quickReply = getQuickReply(message);
    const updatedQuickReply = quickReply.set('quickReplies', options.toJS());
    publishMessage === null || publishMessage === void 0 || publishMessage({
      text,
      quickReply: updatedQuickReply
    });
  }
  renderOptions() {
    const {
      options,
      multiSelect,
      disabled,
      isOutsideChat,
      onSend,
      accentColor
    } = this.props;
    const {
      selected
    } = this.state;
    const onClick = typeof onSend === 'function' ? onSend : multiSelect ? this.handleSelect : this.handleSendIndividual;
    return options.map(option => {
      const boundOnClick = () => onClick(option);
      const checked = selected.includes(option);
      const value = getOptionValue(option);
      const label = getOptionLabel(option);
      if (!value || !label) {
        return null;
      }
      const checkbox = multiSelect && !isOutsideChat && /*#__PURE__*/_jsx(UpdatedCheckbox, {
        checked: checked,
        onChange: boundOnClick,
        children: label
      });
      return /*#__PURE__*/_jsx(QuickReplyButton, {
        "data-test-id": `quick-reply-button-${value}`,
        onClick: boundOnClick,
        disabled: disabled,
        accentColor: accentColor,
        children: checkbox || label
      }, `quickreply.${value}`);
    });
  }
  renderSendButton() {
    const {
      disabled,
      multiSelect
    } = this.props;
    if (!multiSelect) {
      return null;
    }
    const disableQuickReply = !this.hasSelected() || disabled;
    return /*#__PURE__*/_jsx(VizExIconButton, {
      disabled: disableQuickReply,
      onClick: this.handleSendMulti,
      size: "sm",
      "data-test-id": "quick-reply-send-button",
      children: /*#__PURE__*/_jsx(VizExIcon, {
        icon: /*#__PURE__*/_jsx(SVGSuccess, {}),
        size: "sm"
      })
    }, "send-button");
  }
  render() {
    const {
      isOutsideChat,
      widgetLocation
    } = this.props;
    const ButtonWrapper = isOutsideChat ? ButtonWrapperOutsideChat : ButtonWrapperInsideChat;
    return /*#__PURE__*/_jsx(ButtonWrapper, {
      $widgetLocation: widgetLocation,
      "data-test-id": "quick-reply-group",
      children: [...this.renderOptions(), this.renderSendButton()]
    });
  }
}
QuickReplyGroup.displayName = 'QuickReplyGroup';
QuickReplyGroup.contextType = ThemeContext;
QuickReplyGroup.defaultProps = {
  multiSelect: false,
  isOutsideChat: false
};
export default QuickReplyGroup;